import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { NavLink } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import { getAccessToken } from '../../services/tokenManager';
import { useI18n } from '../../i18n/I18nContext';

function StatCard({ title, value, icon, gradient }) {
  return (
    <div className="col-12 col-md-6 col-lg-3">
      <div className="card border-0" style={{ borderRadius: '1.125rem', boxShadow: '0 0.75rem 1.875rem rgba(0,0,0,0.12)', background: gradient }}>
        <div className="card-body text-white">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <span className="opacity-75">{title}</span>
            <i className={icon} style={{ color: '#fff' }}></i>
          </div>
          <div className="h4 mb-0 fw-bold">{value}</div>
        </div>
      </div>
    </div>
  );
}

function AdminDashboard() {
  const { t } = useI18n();
  const [stats, setStats] = useState({ transporteurs: 0, expediteurs: 0, chauffeurs: 0, missions: 0, vehicules: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/admin/stats`, {
          credentials: 'include',
          headers: {
            'Authorization': `Bearer ${getAccessToken() || ''}`,
            'Content-Type': 'application/json'
          }
        });
        const data = await res.json();
        setStats(data || {});
      } catch (e) {
        setError(t('common.error'));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [t]);

  return (
    <DashboardLayout>
      <div className="modern-dashboard" style={{ background: '#f8fafc', minHeight: '100vh', padding: '2rem' }}>
        {/* Header */}
        <div className="dashboard-header mb-4">
          <h1 className="display-6 fw-bold text-dark mb-1">{t('admin.dashboard.title')}</h1>
          <p className="text-muted mb-0">{t('admin.dashboard.subtitle')}</p>
        </div>

        {/* KPI Cards */}
        <div className="row g-3 mb-4">
          <StatCard title={t('admin.dashboard.stats.transporteurs')} value={stats.transporteurs ?? 0} icon="bi bi-truck" gradient="linear-gradient(135deg,#0ea5e9 0%, #2563eb 100%)" />
          <StatCard title={t('admin.dashboard.stats.expediteurs')} value={stats.expediteurs ?? 0} icon="bi bi-briefcase" gradient="linear-gradient(135deg,#8b5cf6 0%, #7c3aed 100%)" />
          <StatCard title={t('admin.dashboard.stats.chauffeurs')} value={stats.chauffeurs ?? 0} icon="bi bi-people" gradient="linear-gradient(135deg,#10b981 0%, #059669 100%)" />
          <StatCard title={t('admin.dashboard.stats.missions')} value={stats.missions ?? 0} icon="bi bi-list-check" gradient="linear-gradient(135deg,#f59e0b 0%, #d97706 100%)" />
        </div>


        {/* Quick Actions */}
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <div className="card border-0" style={{ borderRadius: '1.125rem', boxShadow: '0 0.375rem 1.375rem rgba(0,0,0,0.08)' }}>
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <div className="fw-semibold">{t('admin.dashboard.quickActions.createAccount')}</div>
                  <div className="text-muted small">{t('admin.dashboard.quickActions.createAccountSub')}</div>
                </div>
                <NavLink to="/admin/users/create" className="btn btn-primary">
                  {t('admin.dashboard.quickActions.open')}
                </NavLink>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card border-0" style={{ borderRadius: '1.125rem', boxShadow: '0 0.375rem 1.375rem rgba(0,0,0,0.08)' }}>
              <div className="card-body d-flex align-items-center justify-content-between">
                <div>
                  <div className="fw-semibold">{t('admin.dashboard.quickActions.limits')}</div>
                  <div className="text-muted small">{t('admin.dashboard.quickActions.limitsSub')}</div>
                </div>
                <NavLink to="/admin/transporteurs/limits" className="btn btn-outline-primary">
                  {t('admin.dashboard.quickActions.manage')}
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {loading && (
          <div className="text-muted small mt-3">{t('common.loading')}</div>
        )}
        {error && (
          <div className="alert alert-danger mt-3">{error}</div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default AdminDashboard;


